export interface VariableGroup {
  label: string;
  variables: { token: string; description: string }[];
}

export const VARIABLE_GROUPS: VariableGroup[] = [
  {
    label: "Personalización",
    variables: [
      { token: "{{first_name}}", description: "Primer nombre del contacto" },
      { token: "{{last_name}}", description: "Apellido" },
      { token: "{{email}}", description: "Email del contacto" },
      { token: "{{phone}}", description: "Teléfono" },
      { token: "{{country}}", description: "País" },
    ],
  },
  {
    label: "Negocio",
    variables: [
      { token: "{{model_purchased}}", description: "Modelo TVS adquirido" },
      { token: "{{dealer_name}}", description: "Nombre del concesionario" },
      { token: "{{dealer_phone}}", description: "Teléfono del concesionario" },
    ],
  },
  {
    label: "Sistema SendGrid",
    variables: [
      { token: "[Unsubscribe]", description: "Link de unsubscribe (Marketing Campaigns)" },
      { token: "[Unsubscribe_Preferences]", description: "Centro de preferencias" },
      { token: "{{Sender_Name}}", description: "Nombre del remitente configurado" },
      { token: "{{Sender_Address}}", description: "Dirección física del remitente" },
    ],
  },
  {
    label: "Genéricas",
    variables: [
      { token: "{{subject}}", description: "Asunto" },
      { token: "{{preheader_text}}", description: "Texto preheader" },
      { token: "{{cta_url}}", description: "URL del CTA principal" },
      { token: "{{cta_label}}", description: "Texto del CTA principal" },
      { token: "{{year}}", description: "Año actual" },
    ],
  },
];
